import COUNTRIES from "./countries.json";

import type { CountryType, CurrencyType } from './types'

export const findCountryByValue = (value: string | undefined): CountryType | undefined => {
  return COUNTRIES.find((country) => country.value === value);
}

export const filterCountries = (query: string) => {
  return COUNTRIES.filter((country) =>
    country.title.toLowerCase().startsWith(query.toLowerCase())
  )
}

export const findCountryByCurrencyCode = (value: string | undefined): CountryType | undefined => {
  return COUNTRIES.find((country) => country.currency.code === value);
}

export const findCurrencyByCode = (value: string | undefined): CurrencyType | undefined => {
  const country = findCountryByCurrencyCode(value)
  return country?.currency;
}

export const currencyOptions = (): {value: string, label: string}[] => {
  return COUNTRIES.map((country) => {
    return { 
      value: country.currency.code, 
      label: `(${country.currency.code} ${country.flag} ${country.title})`,
      symbol: country.currency.symbol,
      country: country.title
    }
  })
}

export const findCountryPlaceholder = (value: string | undefined): string | undefined => {
  const country = findCountryByValue(value);
  return country?.placeholder;
}

export const findCapitalCoordinates = (value: string | undefined): string[] | undefined => {
  const country = findCountryByValue(value);
  if (!country) return;

  return [country.capital.longitude, country.capital.latitude];
}
